import React from 'react';
import cn from 'classnames';
import { string, func, bool, number } from 'prop-types';

/**
 * CustomArrow for SlickSlider
 * @param {string} className
 * @param {boolean} isSmall indicate if the arrow is small size
 * @param {string} direction PREV/NEXT
 * @param {function} onArrowClick callback for arrow click (since onClick cannot be overridden)
 *
 * @summary The next params are reserved SlickSlider params and cannot be overridden
 * @see {@link https://github.com/akiran/react-slick/blob/master/src/arrows.js}
 * @param {number} currentSlide - SlickSlider current slide index
 * @param {function} onClick - SlickSlider arrow onClick behavior
 */

const CustomArrow = ({ className, onClick, onArrowClick, isSmall, direction, currentSlide }) => (
    <button className={cn(className, { 'small-arrow': isSmall })}
        onClick={(...params) => {
            onClick(...params);
            onArrowClick({ direction, currentSlide });
        }}/>
);

CustomArrow.propTypes = {
    className: string,
    direction: string,
    currentSlide: number,
    isSmall: bool,
    onClick: func,
    onArrowClick: func
};

export default CustomArrow;
